import axios from 'axios';
import dataApi from '../dataApi';
import nirServiceApi from 'apis/nirServiceApi';

class HttpAuthApi {
  constructor(baseURL = process.env.REACT_APP_AUTH_API_URL) {
    this.baseURL = baseURL;
    this.httpClient = axios.create({
      baseURL,
      headers: { 'content-type': 'application/json', 'X-Frame-Options': 'deny' }
    });
  }

  authenticate = loginToken => {
    return this.httpClient.get(
      'saml/login',
      {
        params: {
          loginToken
        }
      },
      { baseURL: this.baseURL }
    );
  };

  setAuthToken = token => {
    this.httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
    // TODO Refactor to use events
    nirServiceApi.setAuthToken(token);
    dataApi.setAuthToken(token);
  };

  removeAuthToken = () => {
    this.httpClient.defaults.headers.common.Authorization = undefined;
    // TODO Refactor to use events
    nirServiceApi.removeAuthToken();
    dataApi.removeAuthToken();
  };
}

export default HttpAuthApi;
